module.exports = __webpack_public_path__ + "img/product-optimizer-img.e7b8fa98.jpg";